import React, { useState } from 'react'
import PropTypes from 'prop-types'
import SelectionTabs from './SelectionTabs'
import SelectionPane from './SelectionPane'

const SelectionCard = ({ tabList, onTabChange }) => {
  const [activeTab, setActiveTab] = useState(0)

  const handleSetActiveTab = tabIndex => {
    setActiveTab(tabIndex)
    onTabChange(tabIndex)
  }

  return (
    <div>
      <SelectionTabs
        activeTab={activeTab}
        setActiveTab={handleSetActiveTab}
        tabList={tabList}
      />
      <SelectionPane
        activeTab={activeTab}
        paneList={tabList}
      />
    </div>
  )
}

SelectionCard.propTypes = {
  tabList: PropTypes.arrayOf(
    PropTypes.shape({
      productCode: PropTypes.string,
      channel: PropTypes.string,
      title: PropTypes.node.isRequired,
      subTitle: PropTypes.node,
      paneTitle: PropTypes.node,
      description: PropTypes.node,
      onlineInStore: PropTypes.bool,
      preApproved: PropTypes.bool,
      onlineOnly: PropTypes.bool,
    })
  ).isRequired,
  onTabChange: PropTypes.func,
}

SelectionCard.defaultProps = {
  onTabChange: () => { },
}

export default SelectionCard
